import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import card1 from '../assets/images/Marketplace/artwork-card-1.png';
import card2 from '../assets/images/Marketplace/artwork-card-2.png';
import card3 from '../assets/images/Marketplace/artwork-card-3.png';
import card4 from '../assets/images/Marketplace/artwork-card-4.png';
import card5 from '../assets/images/Marketplace/artwork-card-5.png';
import card6 from '../assets/images/Marketplace/artwork-card-6.png';
import card7 from '../assets/images/Marketplace/artwork-card-7.png';
import card8 from '../assets/images/Marketplace/artwork-card-8.png';
import Header from './Header';

class Marketplace extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Breadcrum area start */}
                <div className="container-fluid marketplace text-center">
                    <div className="row">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            <h1>Marketplace</h1>
                            <p>The marketplace is where NFTs are traded user to user.<br /> Go to Drops to buy direct from creators.</p>
                        </div>
                        <div className="col-lg-2"></div>
                    </div>
                </div>
                {/* Breadcrum area end */}

                {/* MArketplace area start */}
                <main className="main container-fluid">
                    <nav id="navbar" className="navbar">
                        <ul className="text-left">
                            <li className="nav-link"><h1>Filters</h1></li>
                            <li className="nav-link">
                                <label className="switch">
                                    <input type="checkbox" />
                                    <span className="slider round"></span>
                                </label>
                            </li>
                            <li className="nav-link"><h4>Artists</h4></li>
                            <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                            <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                            <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                            <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                            <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                            <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                            <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                            <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                            <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                            <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                            <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                            <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                        </ul>
                    </nav>
                    <nav className="navbar">
                        <ul className="text-left">
                            <h4>Collections</h4>
                            <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                            <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                            <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                            <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                            <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                            <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                            <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                            <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                            <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                            <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                        </ul>
                    </nav>
                    <nav className="marketplace-card">
                        <div className="row justify-content-between">
                            <h4>Marketplace</h4>
                            <h4>Sort By <i className="fa fa-arrow-up"></i><i className="fa fa-arrow-down"></i></h4>
                        </div>
                        <div className="most-popular justify-content-center row">
                            <div className="card">
                                <Link to="/SpecificItem">
                                    <img src={card1} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/SpecificItem">
                                        <h3>Artwork Title</h3>
                                    </Link>
                                    <span><strong>Not for Sale</strong>&emsp;<small>1 OF 26</small></span>
                                    <p className="card-text"><span><small>LAST SOLD</small>&emsp;<strong>$89,000.00</strong></span></p>
                                </div>
                            </div>
                            <div className="card">
                                <Link to="/SpecificItem">
                                    <img src={card2} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/SpecificItem">
                                        <h3>Artwork Title</h3>
                                    </Link>
                                    <span><strong>$ 60,000.00</strong>&emsp;<small>2 OF 26</small></span>
                                    <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$49,000.00</strong></span></p>
                                </div>
                            </div>
                            <div className="card">
                                <Link to="/SpecificItem">
                                    <img src={card3} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/SpecificItem">
                                        <h3>Artwork Title</h3>
                                    </Link>
                                    <span><strong>$ 50,000.00</strong>&emsp;<small>3 OF 26</small></span>
                                    <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$13,000.00</strong></span></p>
                                </div>
                            </div>
                            <div className="card">
                                <Link to="/SpecificItem">
                                    <img src={card4} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/SpecificItem">
                                        <h3>Artwork Title</h3>
                                    </Link>
                                    <span><strong>$ 40,000.00</strong>&emsp;<small>4 OF 26</small></span>
                                    <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$8,000.00</strong></span></p>
                                </div>
                            </div>
                            <div className="card">
                                <Link to="/SpecificItem">
                                    <img src={card5} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/SpecificItem">
                                        <h3>Artwork Title</h3>
                                    </Link>
                                    <span><strong>Not for Sale</strong>&emsp;<small>5 OF 26</small></span>
                                    <p className="card-text"><span><small>LAST SOLD</small>&emsp;<strong>$89,000.00</strong></span></p>
                                </div>
                            </div>
                            <div className="card">
                                <Link to="/SpecificItem">
                                    <img src={card6} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/SpecificItem">
                                        <h3>Artwork Title</h3>
                                    </Link>
                                    <span><strong>$ 60,000.00</strong>&emsp;<small>6 OF 26</small></span>
                                    <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$49,000.00</strong></span></p>
                                </div>
                            </div>
                            <div className="card">
                                <Link to="/SpecificItem">
                                    <img src={card7} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/SpecificItem">
                                        <h3>Artwork Title</h3>
                                    </Link>
                                    <span><strong>$ 50,000.00</strong>&emsp;<small>7 OF 26</small></span>
                                    <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$13,000.00</strong></span></p>
                                </div>
                            </div>
                            <div className="card">
                                <Link to="/SpecificItem">
                                    <img src={card8} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/SpecificItem">
                                        <h3>Artwork Title</h3>
                                    </Link>
                                    <span><strong>$ 40,000.00</strong>&emsp;<small>8 OF 26</small></span>
                                    <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$8,000.00</strong></span></p>
                                </div>
                            </div>
                        </div>
                    </nav>
                </main>
                {/* MArketplace area end */}
            </div>
        )
    }
};

export default Marketplace;